var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "104.6%",
    height: "102.1%",
    x: "-2.3%",
    y: "-1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 1,
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0953616696 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    filter: "url(#prefix__a)",
    transform: "translate(-282 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(286 31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.815,
    cy: 3.45,
    r: 1,
    fill: "#CECBCB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M6.487 5.663v2.663c0 .37-.3.672-.672.672-.37 0-.672-.301-.672-.672V5.663c0-.37.301-.672.672-.672.372 0 .672.301.672.672z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECBCB",
    d: "M5.815 0C2.604 0 0 2.604 0 5.815c0 3.212 2.604 5.816 5.815 5.816 3.212 0 5.816-2.604 5.816-5.816C11.63 2.604 9.027 0 5.815 0zm3.381 9.196c-1.204 1.225-2.973 1.71-4.634 1.27-1.66-.44-2.958-1.737-3.398-3.397-.44-1.661.045-3.43 1.27-4.635C3.64 1.21 5.408.724 7.07 1.164c1.66.44 2.957 1.737 3.397 3.398.44 1.66-.045 3.43-1.27 4.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECBCB",
    d: "M5.815 0C2.604 0 0 2.604 0 5.815c0 3.212 2.604 5.816 5.815 5.816 3.212 0 5.816-2.604 5.816-5.816C11.63 2.604 9.027 0 5.815 0zm3.381 9.196c-1.204 1.225-2.973 1.71-4.634 1.27-1.66-.44-2.958-1.737-3.398-3.397-.44-1.661.045-3.43 1.27-4.635C3.64 1.21 5.408.724 7.07 1.164c1.66.44 2.957 1.737 3.397 3.398.44 1.66-.045 3.43-1.27 4.634z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.549b062c6f71acfb7fc8c9292febec2a.svg";
export { ForwardRef as ReactComponent };